import { inject, Pipe, PipeTransform } from '@angular/core';
import { Company } from '@app/features/companies/company.model';
import { CompanyService } from '@app/features/companies/company.service';

@Pipe({
  name: 'companyName',
})
export class CompanyNamePipe implements PipeTransform {
  private companyService = inject(CompanyService);

  transform(value: string | Company, defaultValue = ''): string {
    if (typeof value === 'string' && value.trim() !== '') {
      try {
        const company = this.companyService.findById(value);
        return company?.name ?? defaultValue;
      } catch (error) {
        console.error(error);
        return defaultValue;
      }
    } else if (
      typeof value === 'object' &&
      value !== null &&
      'name' in value &&
      typeof value.name === 'string'
    ) {
      return value.name;
    }
    return defaultValue;
  }
}
